const mobMenu = {
  nextLevel: document.querySelectorAll(
    '.jsNextLevel',
  ) as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(
    '.jsPrevLevel',
  ) as NodeListOf<HTMLElement>,
  close: document.getElementById('jsCloseMenu') as HTMLElement,
  menuLinks: document.querySelectorAll(
    '.jsMenuLink',
  ) as NodeListOf<HTMLElement>,
  showcaseSections: document.querySelectorAll(
    '.jsShowcaseSection',
  ) as NodeListOf<HTMLElement>,
  overlay: document.getElementById('overlay') as HTMLElement,

  init() {
    this.setNextLevel();
    this.setNextLevelMatches();
    this.setPrevLevel();
    this.closeOverlay();
  },

  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement;
      if (subMenu) {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          this.showcaseSections.forEach((item) => {
            item.classList.add('activeClass');
          });
          subMenu.classList.add('activeClass');
        });
      }

      this.close.addEventListener('click', () => {
        this.showcaseSections.forEach((item) => {
          item.classList.remove('activeClass');
        });
        subMenu.classList.remove('activeClass');
      });
    });
  },

  setNextLevelMatches() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement;
      const menuName = item.getAttribute('data-menu');

      if (subMenu && menuName) {
        this.menuLinks.forEach((menuLink) => {
          const menuLinkName = menuLink.getAttribute('data-menu');

          menuLink.addEventListener('click', (e) => {
            e.preventDefault();

            if (menuLinkName === menuName) {
              this.showcaseSections.forEach((item) => {
                item.classList.add('activeClass');
              });
              subMenu.classList.add('activeClass');
            } else {
              subMenu.classList.remove('activeClass');
            }
          });
        });

        const close = subMenu.querySelector('.close');
        if (close) {
          close.addEventListener('click', () => {
            this.showcaseSections.forEach((item) => {
              item.classList.remove('activeClass');
            });
            subMenu.classList.remove('activeClass');
          });
        }
      }
    });
  },

  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement;
      if (menu) {
        item.addEventListener('click', () => {
          menu?.classList.remove('activeClass');
        });
      }
      this.close.addEventListener('click', () => {
        menu?.classList.remove('activeClass');
      });
    });
  },

  closeOverlay() {
    this.overlay.addEventListener('click', () => {
      this.showcaseSections.forEach((item) => {
        item.classList.remove('activeClass');
      });
    });
  },
};

export default mobMenu;
